module.exports = __webpack_public_path__ + "media/images/members/right-0e630aced54f9f38232c4199821eceb0.svg";